import React from 'react'
import ReactDOM from 'react-dom/client'
import SApp from './SApp'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SApp />
  </React.StrictMode>,
)